import { render } from "./HeaderNavFive.vue?vue&type=template&id=54976c6a"
import script from "./HeaderNavFive.vue?vue&type=script&lang=js"
export * from "./HeaderNavFive.vue?vue&type=script&lang=js"

import "./HeaderNavFive.vue?vue&type=style&index=0&id=54976c6a&lang=scss"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__